import { useState } from 'react';
import Hero from './components/Hero';
import GiveawayButton from './components/GiveawayButton';
import About from './components/About';
import Music from './components/Music';
import PreviousAlbum from './components/PreviousAlbum';
import Platforms from './components/Platforms';
import Merch from './components/Merch';
import Gallery from './components/Gallery';
import Footer from './components/Footer';

export default function Home() {
  const [showNewsletter, setShowNewsletter] = useState(false);

  return (
    <div className="bg-black min-h-screen text-white">
      <Hero onNewsletterClick={() => setShowNewsletter(true)} />
      <GiveawayButton />
      <About />
      <Music />
      <PreviousAlbum />
      <Platforms />
      <Merch />
      <Gallery />
      <Footer showNewsletter={showNewsletter} onClose={() => setShowNewsletter(false)} />
    </div>
  );
}
